import { useMedplum, useMedplumProfile } from '@medplum/react-hooks';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isPatientProfile } from '../../features/portal/auth/patientRole';

/**
 * Authenticated-route guard (SPEC §10.1). While the Medplum session resolves we
 * render nothing; with no profile we bounce to `/signin` (preserving the intended
 * location); otherwise the nested chrome + feature routes render.
 *
 * ROLE isolation (issue #154): a Patient profile must never see the clinician UI,
 * so a patient session that lands on a clinician route is sent to the portal.
 * The mirror guard `RequirePatientAuth` keeps clinicians out of the portal.
 */
export function RequireAuth() {
  const medplum = useMedplum();
  const profile = useMedplumProfile();
  const location = useLocation();

  if (medplum.isLoading()) {
    return <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  }

  if (!profile) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  if (isPatientProfile(profile)) {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
}
